import { AppRoutes } from './modules/app-route/models/app-route.model';

/**
 * Application routes
 */
export const routes: AppRoutes = [
  {
    path: 'aktuell',
    loadChildren: () => import('./pages/aktuell/aktuell.routes').then(mod => mod.AKTUELL_ROUTES),
  },
  {
    path: 'wetter',
    loadChildren: () => import('./pages/wetter/wetter.routes').then(mod => mod.WETTER_ROUTES),
  },
  {
    path: 'wetter-aushang',
    loadChildren: () => import('./pages/wetter-aushang/wetter-aushang.routes').then(mod => mod.WETTER_AUSHANG_ROUTES),
  },
  // {
  //   path: 'vorhersage',
  //   loadChildren: () => import('./modules/vorhersage/vorhersage.module').then(mod => mod.VorhersageModule),
  // },
  {
    path: 'termine',
    loadChildren: () => import('./pages/termine/termine.routes').then(mod => mod.TERMINE_ROUTES),
  },
  {
    path: 'boote',
    loadChildren: () => import('./pages/boote/boote.routes').then(mod => mod.BOOTE_ROUTES),
  },
  {
    path: 'jugend',
    loadChildren: () => import('./pages/jugend/jugend.routes').then(mod => mod.JUGEND_ROUTES),
  },
  {
    path: 'regatta',
    loadChildren: () => import('./pages/regatta/regatta.routes').then(mod => mod.REGATTA_ROUTES),
  },
  {
    path: 'links',
    loadChildren: () => import('./pages/links/links.routes').then(mod => mod.LINKS_ROUTES),
  },
  {
    path: 'kontakt',
    loadChildren: () => import('./pages/kontakt/kontakt.routes').then(mod => mod.KONTAKT_ROUTES),
  },
  {
    path: 'ansprechpartner',
    loadChildren: () => import('./pages/ansprechpartner/ansprechpartner.routes').then(mod => mod.ANSPRECHPARTNER_ROUTES),
  },
  {
    path: 'impressum',
    loadChildren: () => import('./pages/impressum/impressum.routes').then(mod => mod.IMPRESSUM_ROUTES),
  },
  {
    path: 'datenschutz',
    loadChildren: () => import('./pages/datenschutz/datenschutz.routes').then(mod => mod.DATENSCHUTZ_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes').then(mod => mod.AUTH_ROUTES)
  },
  {
    path: 'member',
    loadChildren: () => import('./pages/member/member.routes').then(mod => mod.ROUTES)
  },
  {
    path: 'ref',
    loadChildren: () => import('./pages/ref/ref.routes').then(mod => mod.ROUTES)
  },
  {
    path: 'videos',
    loadChildren: () => import('./pages/videos/video.routes').then(mod => mod.VIDEO_ROUTES)
  },
  // {
  //   path: 'member-support',
  //   loadChildren: () => import('./modules/member-support/member-support.routes').then(mod => mod.ROUTES)
  // },
  // {
  //   path: 'member-admin',
  //   loadChildren: () => import('./modules/member-admin/member-admin.routes').then(mod => mod.ROUTES)
  // },
  {
    path: '',
    loadChildren: () => import('./pages/club/club.routes').then(mod => mod.CLUB_ROUTES)
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];